import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LysingListComponent } from './lysing-list/lysing-list.component';
import { AccessioningListComponent } from './accessioning-list/accessioning-list.component';
import { IsolationListComponent } from './isolation-list/isolation-list.component';
import { EchoListComponent } from './echo-list/echo-list.component';
import { TprepListComponent } from './tprep-list/tprep-list.component';
import { ConfigComponent } from './config/config.component';
import { TrackerComponent } from './tracker/tracker.component';
import { ErrorComponent } from './error/error.component';
import { LabMapComponent } from './lab-map/lab-map.component';
//import { NgWhiteboardModule } from 'ng-whiteboard';
import { MachineDetailComponent } from './machine-detail/machine-detail.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { IsoCjunGraphComponent } from './iso-cjun-graph/iso-cjun-graph.component';
import { AbiGraphsComponent } from './abi-graphs/abi-graphs.component';
import { EchoGraphsComponent } from './echo-graphs/echo-graphs.component';
import { OpsAppShellComponent } from './ops-app/ops-app-shell/ops-app-shell.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';


import { ChartModule } from 'primeng/chart';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { TimelineModule } from 'primeng/timeline';
import { PanelModule } from 'primeng/panel';
import { TabMenuModule } from 'primeng/tabmenu';
import { MessageService } from 'primeng/api';
import { InputSwitchModule } from 'primeng/inputswitch';

import { AuthModule, AuthHttpInterceptor  } from '@auth0/auth0-angular';

import { OpsAppModule } from './ops-app/ops-app.module';

import { DataService } from './services/data.service';

import { environment } from '../environments/environment';

import { GlobalHttpInterceptor } from './interceptors/global-http.interceptor';
import { ThemeService } from './services/theme.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LysingListComponent,
    AccessioningListComponent,
    IsolationListComponent,
    EchoListComponent,
    TprepListComponent,
    ConfigComponent,
    TrackerComponent,
    ErrorComponent,
    LabMapComponent,
    MachineDetailComponent,
    DashboardComponent,
    IsoCjunGraphComponent,
    AbiGraphsComponent,
    EchoGraphsComponent,
    OpsAppShellComponent,
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule,
    ButtonModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ChartModule,
    MenubarModule,
    MenuModule,
    InputTextModule,
    TableModule,
    CardModule,
    DropdownModule,
    FormsModule,
    FileUploadModule,
    MessagesModule,
    MessageModule,
    ToggleButtonModule,
    CheckboxModule,
    CalendarModule,
    ToastModule,
    InputNumberModule,
    TimelineModule,
    //NgWhiteboardModule,
    OpsAppModule,
    ProgressSpinnerModule,
    PanelModule,
    TabMenuModule, 
    InputSwitchModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        // Request this audience at user authentication time
        audience: environment.auth0.audience,
    
        // Request this scope at user authentication time
        scope: environment.auth0.scope,
        redirect_uri: window.location.origin
      },
      httpInterceptor: {
        allowedList: [
          {
            // Match any request that starts 'https://transnetyx-poc.us.auth0.com/api/v2/' (note the asterisk)
            uri: environment.apiUrl + '*',
            tokenOptions: {
            }
          }
        ]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,//!isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    DataService, 
    MessageService,
    ThemeService,
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: AuthHttpInterceptor, 
      multi: true 
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: GlobalHttpInterceptor,
        multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
